import packageInfo from '../../package.json';

export const config = {
  api: process.env.REACT_APP_API,
  sentry: process.env.REACT_APP_SENTRY,
  env: process.env.REACT_APP_ENV,
  version: packageInfo.version,
  name: packageInfo.name,
};
